export default "__VITE_ASSET__D7XhW6Lo__"